import { withLayout } from '../../layout';

import CompanyPage from './company.page';

export default withLayout(CompanyPage);
